import { copyToClipboard } from './copyToClipboard';

type UserIdChipProps = {
  userId: number;
};

function CopyIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.3" aria-hidden="true" focusable="false">
      <rect x="5.5" y="5.5" width="8" height="9" rx="1.5" />
      <path d="M10.5 3.5v-1a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1" />
    </svg>
  );
}

function UserIdChip({ userId }: UserIdChipProps) {
  const copyUserId = (): void => {
    void copyToClipboard(String(userId));
  };

  return (
    <button type="button" className="diagnostics-detail-chip" onClick={copyUserId} aria-label={`Copy user ID ${userId}`}>
      <span className="diagnostics-detail-chip-name">User ID</span>
      <span className="diagnostics-detail-chip-value">{userId}</span>
      <CopyIcon />
    </button>
  );
}

export default UserIdChip;
